import React, { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import {
  StyledEngineProvider,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';
import { useAppSelector } from '@/app/store';
import { getTheme } from '../../shared/theme/theme';
import GlobalStyles from '../../shared/theme/globalStyles';

interface MUIProviderProps {
  children: React.ReactNode;
}

export const MUIProvider: React.FC<MUIProviderProps> = ({ children }) => {
  const themeMode = useAppSelector(state => state.theme.mode);
  const theme = useMemo(() => getTheme(themeMode), [themeMode]);

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};
